export default __webpack_public_path__ + "static/media/IconEmail.2c5f4c37.svg";